import MyUHLInspectionsContainer from "../containers/MyUHLInspectionsContainer";

const MyUHLInspectionsPage = () => {
    return <MyUHLInspectionsContainer />;
};

export default MyUHLInspectionsPage;
